export enum ENUM_HOME_LAYOUT {
  Grid = '0',
  Grouped = '1',
}

export enum ENUM_PAYMENT_OPTIONS {
  Free = 0,
  PPV = 1,
  Subscription = 2,
}

export type TYPE_TRANSACTION = 'movie' | 'suscription';
export type TYPE_MODAL = 'modalLogin' | 'modalRegister' | 'modalTarjetas';
export type MODALES = 'login' | 'register';
